import { GeoJSON, useMap } from 'react-leaflet';
import { useEffect, useState } from 'react';

export const StateBoundaries = () => {
  const [geoData, setGeoData] = useState(null);

  useEffect(() => {
    fetch('/ponds_15cm.geojson')
      .then((res) => res.json())
      .then((data) => setGeoData(data))
      .catch((err) => console.error('Failed to load state boundaries', err));
  }, []);
  const map = useMap();

  const overlayPane = map.getPane('overlayPane');
  if (!overlayPane) {
    const overlayPane = map.createPane('overlayPane');
    overlayPane.style.zIndex = '650'; // Highest z-index for invisible interactive layer
  } else {
    overlayPane.style.zIndex = '650'; // Highest z-index for invisible interactive layer
  }

  const style = {
    color: '#333',
    weight: 1,
    fillOpacity: 0,
  };

  return geoData ? (
    <GeoJSON
      data={geoData}
      style={style}
      pane="overlayPane" // Use the new boundaries pane (above grids, below tooltips)
    />
  ) : null;
};

export const Boundaries = ({ geoData }: { geoData: any }) => {
  const style = {
    color: '#333',
    weight: 1,
    fillOpacity: 0,
  };
  const map = useMap();

  const overlayPane = map.getPane('overlayPane');
  if (!overlayPane) {
    const overlayPane = map.createPane('overlayPane');
    overlayPane.style.zIndex = '650'; // Highest z-index for invisible interactive layer
  } else {
    overlayPane.style.zIndex = '650'; // Highest z-index for invisible interactive layer
  }

  // Create a unique key based on the features length and first feature properties
  const boundariesKey = geoData?.features
    ? `boundaries-${geoData.features.length}-${geoData.features[0]?.properties?.NAME || 'default'}`
    : 'boundaries-empty';

  return geoData ? (
    <GeoJSON
      key={boundariesKey}
      data={geoData}
      style={style}
      pane="overlayPane" // Use the new boundaries pane (above grids, below tooltips)
    />
  ) : null;
};
